import React, { useEffect } from "react";

import Footer from "../Footer";
import Header from "../Header";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { blobURL } from "common/StringUtils";
import { LOCALES } from "common/constants";

const CookiesPage = ({ dashboardFooter }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const user = useSelector((state) => state.auth.user);
  let language = localStorage.getItem("i18nextLng");

  const cookiesPrivacy = `${blobURL}/cookies_privacy.png`;

  return (
    <div className="network-page">
      <Helmet>
        <title>{t("Start your own or invoice privately with Invozio?")}</title>
        <meta
          name="description"
          content={t(
            "Explore the alternatives to traditional employment with Invozio. Minimize the requirements for bookkeeping and focus on your work as a self-employed person."
          )}
        />
        <link rel="canonical" href="https://invozio.com/cookies" />
      </Helmet>
      <Header />
      <Container className="p-0 self_new privacy_plcy_nwws">
        <div className="home-page self_employeees new_desgn_insurance mb-0 p-0">
          <section className="insurns_wrap">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="slf_text">
                    <h3 className="security_about text-uppercase mb-0">
                      {t("Privacy policy")}
                    </h3>
                    <h3 className="fnt_family">
                      {t(
                        "For Self-Employed Individuals and Suppliers, as well as Data Protection Officer & Cookies"
                      )}
                    </h3>
                    {!user && (
                      <Button
                        variant=""
                        className="mt-3 new_theme_btn "
                        onClick={() =>
                          navigate(
                            language === LOCALES.EN_US
                              ? `/emailregister?lang=${LOCALES.EN_US}`
                              : `/e-postregister?lang=${LOCALES.SV_SE}`
                          )
                        }
                      >
                        {t("Create Free Account")}
                      </Button>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="text-right">
                    <img
                      src={cookiesPrivacy}
                      alt="cookies-banner"
                      className="image-fluid"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="newdesign">
            <div className="container p-0">
              <div className="without_background">
                <h5>{t("Privacy policy")}</h5>
                <div className="new_text">
                  <p className="text-align: left">
                    {t("Privacy policy at Invozio LV SIA.")}
                  </p>
                  <p>
                    {t(
                      "The personal integrity of our employees and customers has always been important to us. We want you as a registered user to feel secure in how your data is processed. With this document, we want to inform you about how we collect and process your data, for what purpose we do it and how long it is saved."
                    )}
                  </p>
                  <p>
                    {t(
                      "We also want to tell you about your rights and how you can claim them."
                    )}
                  </p>
                </div>
                <div className="new_text">
                  <p>{t("Personal data controller")}</p>
                  <p>
                    {t(
                      "Invozio LV SIA (hereinafter Invozio, we), reg. No. 502085-4062, is the personal data controller for the personal data processed within the company. Invozio determines the purpose of the processing and how the processing is to take place."
                    )}
                  </p>
                  <p>
                    {t(
                      "Contact details for the personal data controller and the data protection officer can be found at the end of this privacy policy."
                    )}
                  </p>
                </div>
                <div className="new_text">
                  <p className="text-align: left">
                    {t(
                      "What is personal data and what does the processing of personal data mean?"
                    )}
                  </p>
                  <p>
                    {t(
                      "Processing personal data means handling personal data, such as collection, registration, storage, transfer and deletion. Personal data is all information that can be directly or indirectly linked to a physical person who is alive. Personal data includes name, social security number, e-mail addresses, telephone numbers, images and IP numbers."
                    )}
                  </p>
                </div>
                <div className="new_text">
                  <p className="text-align: left">
                    {t("What personal data do we process?")}
                  </p>
                  <p>
                    {t(
                      "Invozio processes many different types of personal data and they depend on the capacity in which you come into contact with us."
                    )}
                  </p>
                </div>
              </div>
              <div className="with_background">
                <div className="new_text">
                  <h5>{t("Self-employed")}</h5>
                  <p className="insurance_para">
                    {t(
                      "If you are self-employed at Invozio, that is, if you have been offered general fixed-term employment with us by using our services for invoicing without your own company, we process the personal data that traditionally occurs within the framework of an employment. This is, for example, name, social security number, address, e-mail address, telephone number, bank account number, credit information, expenditure receipts, educational certificates and correspondence. The processing is necessary for us to be able to employ you and exercise our legal obligations as an employer, to be able to fulfill the agreement with the client you performed the assignment with, to be able to administer client support matters regarding you and the client (customer service), to be able to fulfill our legal obligations towards various authorities and to be able to market our services to you."
                    )}
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="newdesign">
            <div className="container p-0">
              <div className="without_background">
                <h5>{t("Customers & Suppliers")}</h5>
                <div className="new_text">
                  <p className="text-align: left">
                    {t(
                      "If you are a customer of ours because one of our self-employed persons has carried out an assignment for you or if you are a supplier to us, we process, for example, name, social security number, address, e-mail address, telephone number and correspondence. We process this personal data to be able to fulfill our contract with you, to be able to fulfill our legal obligations and to be able to protect our and the self-employed person's legal interests."
                    )}
                  </p>
                </div>
                <div className="new_text">
                  <p className="text-align: left">
                    {t("How and from which sources is the data collected?")}
                  </p>
                  <p>
                    {t(
                      "We collect information about you when you register on our website and create an invoice. We collect the information that you enter in the system yourself. It can e.g. name, social security number, address, e-mail address and professional title. If you received your employment with us through one of our contract customers, we collect corresponding information directly from the customer. In connection with the progress of your employment with us, additional information about you is generated in our systems, such as e.g. your salary specifications, your employment number and your control information. We also collect information about you when you contact us regarding questions relating to your employment with us, e.g. your correspondence, sick leave, educational certificate, etc In addition to the information that you provide to us yourself or that we collect through you using our services or corresponding with us, we may also collect information from a so-called third party. We collect information from third parties, such as credit information from credit reporting agencies and address information from public records."
                    )}
                  </p>
                </div>
              </div>
              <div className="with_background">
                <div className="new_text">
                  <h5>{t("Data Protection Officer & Cookies")}</h5>
                  <p className="insurance_para">
                    {t(
                      "Contact details for the personal data controller and data protection officer"
                    )}
                  </p>
                  <div>
                    <p>{t("Personal data controller:")}</p>
                    <p>
                      {t("Invozio LV SIA, Ahtri 12, 10151 Tallinn, Estland")}
                    </p>
                    <p>{t("Organization number:")}: 502085-4062</p>
                    <p>{t("Telephone number:")} 08-12400133</p>
                    <p>{t("Email address:")} info@invozio.com</p>
                    <p>{t("Data Protection Officer:")}</p>
                    <p>
                      {t(
                        "Our Data Protection Officer (DPO) monitors that we comply with applicable legislation and process your personal data correctly. If you want to contact our Data Protection Officer, please email:"
                      )}{" "}
                      dpo@invozio.com
                    </p>
                  </div>
                  <div>
                    <p>{t("information about cookies")}</p>
                    <p>
                      {t(
                        "Cookies are small text files that are saved on your computer or in your browser when you visit certain web pages. On our website, we use cookies to improve the website's functionality and provide you with analytical information regarding your use of the service, to be able to specify certain settings and to be able to direct relevant marketing to you. You, as a user, can control how cookies are stored on your device. You do this by changing the settings for cookies in your browser. You can then, for example, block cookies or set them to be deleted when you close the browser."
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Container>
      <Footer dashboardFooter={dashboardFooter} />
    </div>
  );
};

export default CookiesPage;
